import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Tooltip } from '@chakra-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const getText = p => {
  return Object.keys(p).map(v => `${v}: ${p[v]} \n`).join('');
};
const PersonalizationInfo = _ref => {
  let {
    personalization
  } = _ref;
  const text = getText(personalization.values);
  return ___EmotionJSX(Tooltip, {
    label: text
  }, ___EmotionJSX("span", null, ___EmotionJSX(FaInfoCircle, {
    style: {
      verticalAlign: 'middle'
    }
  })));
};
export default PersonalizationInfo;